// extracted by mini-css-extract-plugin
export default {"item":"DropdownMenuItem-module__item--PoPUT","focused":"DropdownMenuItem-module__focused--opqQc","link":"DropdownMenuItem-module__link--Ohpmb"};